import { render } from "./BarcodeLabel.vue?vue&type=template&id=7720abc4&scoped=true"
import script from "./BarcodeLabel.vue?vue&type=script&lang=ts"
export * from "./BarcodeLabel.vue?vue&type=script&lang=ts"

import "./BarcodeLabel.vue?vue&type=style&index=0&id=7720abc4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7720abc4"

export default script